import moment from 'moment';

import { DATE_FORMAT } from '@/consts';

import {
  APPLY_FILTERS,
  CLEAR_FILTERS,
  SET_ITEMS,
  RESET,
} from './types';

export const INIT_STATE = {
  filters: {
    page: 1,
    pageSize: 20,
    term: '',
    fromDate: moment().subtract(1, 'year').format(DATE_FORMAT),
    toDate: null,
    status: null
  },
  items: [],
  total: 0,
  summary: {
    pending: 0,
    approved: 0,
    disbursed: 0,
    overdue: 0,
    renewed: 0,
    repaid: 0,
    clients: 0
  }
};

const mutations = {
  [APPLY_FILTERS](state, filters) {
    state.filters = {
      ...state.filters,
      ...filters
    };
  },

  [CLEAR_FILTERS](state) {
    state.filters = { ...INIT_STATE.filters };
  },

  [SET_ITEMS](state, { items, total, summary }) {
    state.items = [...items];
    state.total = total;
    state.summary = { ...summary };
  },

  [RESET](state) {
    Object.keys(INIT_STATE).forEach((key) => {
      if (Object.prototype.hasOwnProperty.call(INIT_STATE, key)) {
        state[key] = INIT_STATE[key];
      }
    });
  },

};

export default mutations;
